
import util from '@/javascript/util'
import { formatDate } from "@/javascript/formatDate"
import bus from '@/javascript/bus'

import goBack from '@/components/public-components/goBack/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'



export default {
directives: {
TransferDom
},
components: {

Previewer,
goBack
},
data() {
return {
minHeight:'',
evalList:[],
tabsListPageNo: 0,
tabsListPageSize: 10,
infiniteStatus: false,
infiniteAll: false,
pageNum:'',
showimgList:[],
userInfo: bus.userInfo
}
},
mounted() {
if (this.$route.params.appCode) {
document.title = this.PAGE_TITLE + '用户评价'
} else {
document.title = this.PAGE_TITLE + '我的点评'
}


this.minHeight = document.documentElement.clientHeight;

this.init()
/**
* 底部加载
*/
window.addEventListener('scroll', () => {
if (util.pullUpLoad() && this.evalList.length > 0) {
this.infinite()
}
})
},
methods: {
init:function(){
if (this.$route.params.appCode) {
this.$http.get('/api/wtcp-comment/public/evaluation/findEvaluationAndReplyPage?appCode='+ this.$route.params.appCode + '&identifer='+ this.$route.params.id + '&moduleCode=' + this.$route.params.moduleCode + '&page=' + this.tabsListPageNo + '&size=' + this.tabsListPageSize ).then((response) => {
if (response.data.data && response.data.data.evalPage) {
const list = response.data.data ? response.data.data.evalPage.content : []
list.map(item => item.createDate = formatDate(item.createDate, 'MM-dd'))
this.evalList = this.evalList.concat(list)
if (response.data.data.evalPage.content.length < this.tabsListPageSize) {
this.infiniteAll = true
}

this.infiniteStatus = false

}else{
this.infiniteAll = true
}
}).then(() => {
const showimgList = document.getElementsByClassName('list-panel')[0].querySelectorAll('img')
const imgList2 = []
if (showimgList.length > 0) {
showimgList.forEach(item => {
imgList2.push({
src: item.src
})
})
this.showimgList = imgList2
}
})
} else {
this.$http.get('/api/wtcp-comment/public/evaluation/getUserEvalList?access_token=' + this.userInfo.access_token + '&deptCode=' + this.DEPT_CODE.DEPTCODE + '&userId=' + this.userInfo.user.id + '&page=' + this.tabsListPageNo + '&size=' + this.tabsListPageSize + '&appCode=62').then((response) =>  {
if (response.data.data && response.data.data.content) {
const list = response.data.data.content ? response.data.data.content : []
list.forEach(item => {
item.createDate = formatDate(item.createDate, 'MM-dd')
})
this.evalList = this.evalList.concat(list)

if (response.data.data.content.length < this.tabsListPageSize) {
this.infiniteAll = true
}

this.infiniteStatus = false

}else{
this.infiniteAll = true
}
}).then(() => {
const showimgList = document.getElementsByClassName('list-panel')[0].querySelectorAll('img')
const imgList2 = []
if (showimgList.length > 0) {
showimgList.forEach(item => {
imgList2.push({
src: item.src
})
})
this.showimgList = imgList2
}
})
}

},
infinite: function () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}

this.infiniteStatus = true
this.tabsListPageNo += 1
this.init()
},
show: function (e) {
e = e || window.event
const target = e.target || e.srcElement
const showimgList = document.getElementsByClassName('list-panel')[0].querySelectorAll('img')

for (let i in showimgList) {
if (target === showimgList[i]) {
this.$refs.previewer.show(parseInt(i))
}
}
}
}
}
